import { TGetUserListDto } from "@/api/services/admin/rso/user/dtos/get-user-list.dto";
import { useEnum } from "@/api/services/global/enum";
import { Table } from "@/components/elements/Table";
import { DATE_TIME_FORMAT } from "@/constants/datetime";
import { EMPTY_STR } from "@/constants/string";
import { useTable } from "@/hooks/useTable";
import { dayjs } from "@/utils/dayjs";
import { findLabelByValue } from "@/utils/object";
import { Stack, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { FC, useMemo } from "react";

// RsoUserTable.tsx
interface RsoUserTableProps {
  users: TGetUserListDto[];
}

export const RsoUserTable: FC<RsoUserTableProps> = ({ users }) => {
  const { data: userActiveStatuses } = useEnum("EUserActiveStatus");
  const isLoading = false;
  const companyUserListData = users;

  const columns = useMemo<MRT_ColumnDef<TGetUserListDto>[]>(
    () => [
      {
        header: "ユーザー名",
        id: "fullName",
        accessorKey: "fullName",
      },
      {
        header: "メールアドレス",
        id: "email",
        accessorKey: "email",
      },
      {
        header: "所属",
        size: 120,
        Cell: ({ row }) => (row.original.isRsoUser ? "支援ユーザー" : "irohana担当者"),
      },
      {
        header: "最終ログイン日時",
        id: "lastLoginAt",
        Cell: ({ row }) => (row.original.lastLoginAt ? dayjs(row.original.lastLoginAt).format(DATE_TIME_FORMAT) : EMPTY_STR.DATE_TIME),
        size: 120,
      },
    ],
    [userActiveStatuses],
  );

  const { table } = useTable({
    columns,
    rows: companyUserListData ?? [],
    pinningColumns: ["manager", "edit"],
    getRowId: (row) => row.id.toString(),
  });

  return (
    <Stack gap={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
        <Typography variant="sub16Bold">支援ユーザー</Typography>
      </Stack>
      <Table table={table} isLoading={isLoading} />
    </Stack>
  );
};
